export const VList = {
template: ` <ul class='menu-list'>
           <slot></slot>
</ul>`
}